module.exports = __webpack_public_path__ + "static/Brennerkerze-2d3b7b694585b9af797ddeceef1a40e3.jpg";